import { ApiClientAxios, apiFactoryConfig } from "@repo/api";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { ms } from "humanize-ms";

export const useInvestorProfileQuestionnaireQuestions = ({
    options,
}: { options?: Partial<UseQueryOptions<ApiClientAxios.QuestionnaireQuestions>> } = {}) => {
    const api = ApiClientAxios.InvestorProfileApiFactory(...apiFactoryConfig);

    return useQuery<ApiClientAxios.QuestionnaireQuestions>({
        queryKey: ["investorProfileQuestions"],
        queryFn: async () => (await api.getInvestorProfileQuestionsApimGet()).data,
        gcTime: ms("1h"),
        staleTime: ms("1h"),
        ...options,
    });
};
